import './donate-shim.scss';

import { FlexibleContentProps } from '@sola/schema/lib/schema.ts';

import { DonateCard } from '../_logic/donate-card.tsx';

export const DonateShim: React.FC<FlexibleContentProps> = ({
  seoLevel,
  ...props
}) => {
  return (
    <div className="DonateShim component component--container">
      <div className="DonateShim__container container">
        <div className="max-w-md mx-auto">
          {props.fund && <DonateCard {...props} seoLevel={seoLevel} />}
        </div>
      </div>
    </div>
  );
};
